import { render, staticRenderFns } from "./DistributionBarCodeScanner.vue?vue&type=template&id=76c68732"
import script from "./DistributionBarCodeScanner.vue?vue&type=script&lang=js"
export * from "./DistributionBarCodeScanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports